import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice, { Option } from '@components/choice/Choice'

import { FormikHelpers, useFormik } from 'formik'

import useI18n from '@i18n/useI18n'

interface Values {
  period?: 'MONTAGE' | 'DEMONTAGE' | 'OUVERTURE_PUBLIC'
}

const Period = ({ form, onForm }: ControleFormProps) => {
  const i18n = useI18n()

  const init: Values = React.useMemo(() => ({ period: form.period }), [form.period])

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options: Option[] = ['MONTAGE', 'OUVERTURE_PUBLIC', 'DEMONTAGE'].map((s) => ({
    label: i18n.t(`screens.controles.form.period.${s}`),
    value: s,
  }))
  const option = options.find((o) => o.value === values.period)

  return (
    <MainContainer>
      <Choice
        data={options}
        onItemSelected={(opt) => setFieldValue('period', opt.value)}
        value={option}
        inline={false}
      />
    </MainContainer>
  )
}

export default Period

const MainContainer = styled(View)`
  margin: 0 20px;
  margin-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 75)}px;
  flex: 1;
`
